import React from "react";

function Abilities(props) {
    return (
        <li>{props.ability}</li>
    );
}

export default Abilities;